import type {TypedDocumentNode} from '@apollo/client';
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

import type {
  GetInsightQuery,
  GetInsightQueryVariables,
} from './useInsight.generated';

export default function useInsight(topicId: number, quoteId: number) {
  const {data} = useQuery(GET_INSIGHT, {
    variables: {topicId, quoteId},
    errorPolicy: 'all',
  });

  return {
    topic: data?.Topic,
    quote: data?.Quote,
  };
}

const GET_INSIGHT: TypedDocumentNode<
  GetInsightQuery,
  GetInsightQueryVariables
> = gql`
  query GetInsight($topicId: Int!, $quoteId: Int!) {
    Topic(id: $topicId) {
      id
      body
    }

    Quote(id: $quoteId) {
      id
      source
      body
    }
  }
`;
